import { useState, useEffect } from 'react';

export const useLocation = () => {
  const [position, setPosition] = useState({ lat: 45.0351532, lon: 38.9772396 });
  const [error, setError] = useState(null);

  const onChange = (event) => {
    const {coords} = event;
    setPosition({lat: coords.latitude, lon: coords.longitude});
  };

  const onError = (error) => {
    setError(error.message);
  };

  useEffect(() => {
    const geo = navigator.geolocation;
    if (!geo) {
      setError('Геолокация не поддерживается браузером');
      return;
    }
    geo.getCurrentPosition(onChange, onError)
  }, []);

  return {...position, error};
}